import { ReactElement } from "react";
import { SxProps, Theme } from "@mui/material/styles";

import { useFloatingChatButtonBottom } from "../../../../features/messaging/useFloatingChatButtonBottom";
import { FLOATING_CHAT_BUTTON_BOTTOM_RAISED } from "../../../../features/messaging/messagingSlice";
import { BannerContainer } from "./styled";

interface Props {
  children: ReactElement | ReactElement[];
  isOpen: boolean;
  sx?: SxProps<Theme>;
}

export const ActionBanner = ({ children, isOpen, sx }: Props) => {
  useFloatingChatButtonBottom(
    isOpen ? FLOATING_CHAT_BUTTON_BOTTOM_RAISED : null,
  );

  return (
    <BannerContainer
      sx={isOpen ? { display: "flex", ...sx } : { display: "none" }}
    >
      {children}
    </BannerContainer>
  );
};
